import type { PartnerWallet } from 'src/interfaces/wallet'
import type { State } from '../reducers/types'

export const getWallets = (state: State): PartnerWallet[] => {
  return state.wallet.wallets
}

export const getWalletsLoading = (state: State): boolean => {
  return state.wallet.loading
}

export const getWalletsError = (state: State): string | null => {
  return state.wallet.error
}
